export default __webpack_public_path__ + "static/media/subaru.d12e9e41.svg";